import { useState, useEffect } from 'react';
import dayjs, { Dayjs } from 'dayjs';

export function useCountdown(expiresAt: Dayjs | null) {
  const [timeLeft, setTimeLeft] = useState<{
    minutes: number;
    seconds: number;
    isExpired: boolean;
  }>({ minutes: 0, seconds: 0, isExpired: true });

  useEffect(() => {
    if (!expiresAt) {
      setTimeLeft({ minutes: 0, seconds: 0, isExpired: true });
      return;
    }

    const updateCountdown = () => {
      const now = dayjs();
      const difference = expiresAt.diff(now);

      if (difference <= 0) {
        setTimeLeft({ minutes: 0, seconds: 0, isExpired: true });
        return;
      }

      const minutes = Math.floor(difference / 1000 / 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeLeft({ minutes, seconds, isExpired: false });
    };

    // Update immediately
    updateCountdown();

    // Update every second
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  return timeLeft;
}
